import { useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';

export function useSession() {
  const { refreshUserData, debitLocalCredits } = useAuth();
  const [sessionCost, setSessionCost] = useState(() => {
    const saved = sessionStorage.getItem('sessionCost');
    return saved ? parseFloat(saved) : 0;
  });
  
  const [sessionTokens, setSessionTokens] = useState(() => {
    try {
      const saved = sessionStorage.getItem('sessionTokens');
      if (saved && saved !== 'undefined') return JSON.parse(saved);
    } catch (e) {}
    return { in: 0, out: 0 };
  });

  const recordUsage = (cost: number, promptTokens: number, completionTokens: number) => {
    setSessionCost(prev => {
      const newCost = prev + cost;
      sessionStorage.setItem('sessionCost', newCost.toString());
      return newCost;
    });
    
    setSessionTokens(prev => {
      const newTokens = { 
        in: prev.in + promptTokens, 
        out: prev.out + completionTokens 
      };
      sessionStorage.setItem('sessionTokens', JSON.stringify(newTokens));
      return newTokens;
    });
    
    try {
      // We rely on the Firestore onSnapshot listener in AuthContext to automatically
      // sync the user's credits. Deducting locally here causes a visual bug where it
      // deducts the amount twice (once locally, once when the snapshot arrives).
    } catch (e) {}
    
    const savedTotal = localStorage.getItem('resumeChecker_totalCost');
    const newTotal = (savedTotal ? parseFloat(savedTotal) : 0) + cost;
    localStorage.setItem('resumeChecker_totalCost', newTotal.toString());

    const savedTokens = localStorage.getItem('resumeChecker_totalTokens');
    let parsedTokens = { in: 0, out: 0 };
    try {
      if (savedTokens && savedTokens !== 'undefined') {
        parsedTokens = JSON.parse(savedTokens);
      }
    } catch (e) {}
    localStorage.setItem('resumeChecker_totalTokens', JSON.stringify({
      in: parsedTokens.in + promptTokens,
      out: parsedTokens.out + completionTokens
    }));
  };

  const resetSession = () => {
    setSessionCost(0);
    setSessionTokens({ in: 0, out: 0 });
    sessionStorage.setItem('sessionCost', '0');
    sessionStorage.setItem('sessionTokens', JSON.stringify({ in: 0, out: 0 }));
  };

  return { sessionCost, sessionTokens, recordUsage, resetSession };
}
